module.exports = __webpack_public_path__ + "static/media/version.56556c1d.txt";